export const cleanFormData = (values) => {
  const cleaned = {};
  Object.keys(values).forEach((key) => {
    const value = values[key];
    cleaned[key] = typeof value === "string" ? value.trim() : value;
  });
  return cleaned;
};
